"use client";
import {
  LinkIcon
} from "./chunk-7LH7ZARU.mjs";
import {
  link_default
} from "./chunk-77LBB3F4.mjs";
import {
  useLink
} from "./chunk-ECGP53KU.mjs";
export {
  link_default as Link,
  LinkIcon,
  useLink
};
